import _Vue from 'vue';
import GamePlayService from '@/services/GamePlayService';
import StateService from '@/services/StateService';

declare module 'vue/types/vue' {
    // noinspection JSUnusedGlobalSymbols
    interface Vue {
        $locator: Locator;
    }
}

export class Locator {
    public stateService: StateService = new _Vue(StateService);
    public gamePlayService: GamePlayService = new GamePlayService(this.stateService);
}

// noinspection JSUnusedLocalSymbols
export default function LocatorPlugin(Vue: typeof _Vue): void {
    // noinspection JSUnusedGlobalSymbols
    Vue.prototype.$locator = new Locator();
}
